<template>
  <div
    v-if="loaded"
    :class="{[size]: size}"
    class="controls"
  >
    <MetaInfo v-if="size !== 'size-mini'" />

    <div class="player-controls">
      <PlayPause />

      <div :class="{'scrubber-timer': true, disabled: !epi || !epi.enclosure_url}">
        <Scrubber />

        <div class="controls-share-subscribe">
          <Share v-if="showShareSubButtons" />
          <Subscribe v-if="showShareSubButtons" />
        </div>

        <div class="left">
          <Speed />
        </div>

        <!-- Only visible on smaller widths -->
        <div class="middle">
          <Rewind v-if="epi" />
          <PlayPause />
          <Forward v-if="epi" />
        </div>

        <div class="right">
          <!-- Changes position on smaller widths -->
          <Share v-if="showShareSubButtons"/>
          <Subscribe v-if="showShareSubButtons" />

          <!-- Only visible on smaller widths -->
          <Artwork />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Controls from './Controls'
import Artwork from './Artwork'
import Forward from './Forward'
import Rewind from './Rewind'
import Speed from './Speed'
import MetaInfo from './MetaInfo'
import PlayPause from './PlayPause'
import Scrubber from './Scrubber'
import Share from './Share'
import Subscribe from './Subscribe'
import Store from '../store'

export default {
  components: {
    Artwork,
    Forward,
    Rewind,
    Speed,
    MetaInfo,
    PlayPause,
    Scrubber,
    Share,
    Subscribe
  },
  data () {
    return { store: Store }
  },
  computed: {
    epi () { return this.store.state.episode },
    showShareSubButtons () { return !this.store.state.hideShareSubscribeButtons },
    loaded () { return this.store.state.isLoaded },
    size () { return this.store.state.size }
  }

}
</script>

<style lang="scss" scoped>
@import '../assets/styles/breakpoints.scss';

.controls {
  align-items: flex-end;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;
  height: 60px;
  min-height: 60px;

  a, button {
    transition: opacity .2s ease-in-out;
    &:focus {
      outline: 0;
      opacity: .6;
    }
  }

  @media (min-width: $bp_xs) {
    align-items: center;
    height: 80px;
    min-height: 80px;
  }
  @media (min-width: $bp_sm) {
    padding-top: 0;
    height: 100%;
  }

  .play-pause {
    display: none;
    height: 42px;
    width: 42px;

    @media (min-width: $bp_xs) {
      display: flex;
      height: 62px;
      margin-right: 12px;
      width: 62px;
    }
    @media (min-width: $bp_sm) {
      height: 70px;
      margin-top: 0;
      width: 70px;
    }
  }
  .meta-info {
    display: none;

    @media (min-width: $bp_sm) {
      display: block;
      box-sizing: border-box;
      height: 50%;
      padding-top: 16px;
    }
  }
  &.size-mini {
    .scrubber-timer {
      > .controls-subscribe {
        display: none;
      }
    }
  }
  .scrubber-timer {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    @media (min-width: $bp_xs) {
      height: 62px;
    }
    @media (min-width: $bp_sm) {
      height: 70px;
    }

    > .controls-share-subscribe {
      flex-basis: 100%;
      margin: 10px 0 23px 0;
      text-align: right;

      @media (min-width: $bp_xs) {
        flex-basis: 50%;
        display: none;
        margin: 0px 0 23px 0;
      }
    }
    &:hover {
      .left,
      .middle,
      .right  {
        opacity: .9;
      }
      .controls-forward,
      .controls-rewind {
        opacity: .75;
      }
    }
    &.disabled {
      display: none
    }
    .controls-forward,
    .controls-rewind {
      opacity: .95;
      height: 20px;
      @media (min-width: $bp_xs) {
        transition: opacity .2s ease-in-out;
        &:focus {
          opacity: .85;
        }
        &:hover {
          opacity: 1;
        }
      }
    }
    .left,
    .middle,
    .right {
      opacity: .95;

      @media (min-width: $bp_xs) {
        opacity: .95;
        transition: opacity .2s ease-in-out;
      }
    }
  }
  .player-controls {
    display: flex;
    box-sizing: border-box;
    @media (min-width: $bp_xs) {
      align-items: center;
      height: 80px;
      width: 100%;
    }
    @media (min-width: $bp_sm) {
      padding-top: 0;
      height: 98px;
      align-items: flex-end;
      padding-bottom: 16px;
      .play-pause {
        align-self: flex-end;
      }
    }
  }
  .left {
    display: flex;
    align-items: center;
    @media (min-width: $bp_sm) {
      height: 24px;
    }
  }
  .middle {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    @media (min-width: $bp_xs) {
      justify-content: flex-start;
      padding-left: 24px;
    }
  }
  .right {
    display: flex;
    align-items: flex-end;
    .controls-speed {
      display: none;
    }
    .controls-share,
    .controls-subscribe:not(.size-mini) {
      display: none;

      @media (min-width: $bp_xs) {
        display: block;
      }
    }
  }
  .artwork {
    height: 44px;
    width: 44px;
    max-width: 100%;
  }
  .artwork,
  .middle button.play-pause {
    display: block;

    @media (min-width: $bp_xs) {
      display: none;
    }
  }
  // MINI PLAYER STYLES
  &.size-mini {
    align-items: flex-start;
    display: flex;
    padding-top: 0;
    height: auto;
    min-height: auto;

    .player-controls {
      padding: 0;
      height: auto;
    }

    > .play-pause {
      margin-top: 0;
    }
    .left,
    .middle,
    .artwork,
    .controls-share {
      display: none;
    }
    .scrubber-timer {
      flex-wrap: nowrap;
      height: auto;
      &.disabled {
        display: none
      }
      > .controls-share-subscribe {
        display: none;
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      opacity: 1;
      padding-left: 8px;
      width: auto;
      .controls-share {
        display: none;
      }
      .controls-speed {
        display: flex;
        justify-content: center;
        width: 100%;
      }
    }
  }
}
</style>
